let component = null;

export default {
    install(app, options) {
        app.config.globalProperties.$showPricingPlans = (filters, key) => {
            component.value.show();
        };

        app.provide("$showPricingPlans", app.config.globalProperties.$showPricingPlans);
        app.provide("setPricingPlansComponent", (el) => {
            component = el;
        });
    },
};
